export function getSearchParams(name, location) {
  try {
    return location
      .split('/')
      .find((path) => path.includes(`${name}=`))
      .split('=')[1];
  } catch (e) {
    return undefined;
  }
}

export function getAllSearchParams(location) {
  try {
    return location
      .split('/')
      .filter((path) => path.includes(`=`))
      .map((x) => x.split('=')[0]);
  } catch (e) {
    return undefined;
  }
}
